import { apiRequest } from '../api-request'
import type { StudentLevelInfo } from 'utils/level-unit-helpers'
import { Guid } from '../unit-assessment/types'

type StudentLevelInfoResponse = {
    studentLevelInfo: StudentLevelInfo
}

const getStudentLevelInfo = async (auth: string, userId: Guid): Promise<StudentLevelInfo> => {
    const response = await apiRequest<StudentLevelInfoResponse>({
        baseUrl: process.env.REACT_APP_BS_API_URL,
        path: `/v2/users/${userId}/state`,
        method: 'GET',
        auth,
        query: {
            fields: 'studentLevelInfo'
        }
    })

    return response.studentLevelInfo
}

export { getStudentLevelInfo }
